import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';

import ResponsiveImage from '../../helpers/responsiveImage/ResponsiveImage';
import getImageDesStyle from '../../helpers/galleryUtils/getImageDescStyle';
import { getActiveSlideId, getSlidesToShow } from '../../helpers/galleryUtils/utils';
import ReactGA from 'react-ga';

import './Style';

class GalleryComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            slidesToShow: 0
        }
    }

    componentDidMount() {
        const thumbnails = document.getElementsByClassName('slider-img-wrapper');
        for (let i = 0; i < thumbnails.length; i++) {
            thumbnails[i].addEventListener('click', this.onThumbnailClick);
        }
    }

    componentWillReceiveProps(nextProps) {
        const { refToSlider, images } = this.props;
        if (refToSlider && typeof refToSlider.slickGoTo == 'function') {
            const activeSlideId = getActiveSlideId(images, nextProps.activeSlideName);
            refToSlider.slickGoTo(activeSlideId);
        }
    }

    shouldComponentUpdate(nextProps) {
        if (nextProps.activeSlideName === this.props.activeSlideName) {
            return true;
        } else {
            const nextPropsObj = {...nextProps, activeSlideName: undefined, refToSlider: undefined};
            const propsObj = {...this.props, activeSlideName: undefined, refToSlider: undefined};
            // do not rerender if nextProps and this.props is equal not considering property 'activeSlide'
            //TODO: Find better way to compare
            return JSON.stringify(nextPropsObj) === JSON.stringify(propsObj) ? false : true;
        }
    }

    componentWillUnmount() {
        const thumbnails = document.getElementsByClassName('slider-img-wrapper');
        for (let i = 0; i < thumbnails.length; i++) {
            thumbnails[i].removeEventListener('click', this.onThumbnailClick);
        }
    }

    onThumbnailClick() {
        //  ReactGA.event({
        //     category: 'floorplan',
        //     action: 'click thumbnail image'
        // });
    }

    render() {
        const {parentName, imagesPath, images, imageSizeParams} = this.props;

        if (!imagesPath || images.length === 0) {
            return null;
        }

        const responsiveImage = image => {
            const descriptionBlock = parentName === 'galleryContainer'
                && image.description.text.length
                ? (
                    <p className="main-img-description" style={getImageDesStyle(image.description)}>
                        {image.description.text}
                    </p>
                )
                : null;

            return this.props.className === 'gallery-secondary'
                ? (
                    <div className="slider-img-wrapper">
                        <ResponsiveImage
                            imagesPath={imagesPath}
                            imageSizeParams={imageSizeParams}
                            filename={image.file_name}
                            lazyLoad={this.props.lazyLoad}
                        />
                        {image.title && image.title.length
                            ? (
                                <div className="slider-img-title">
                                    <span>{image.title}</span>
                                </div>
                            )
                            : null}

                        {image.text && image.text.length
                            ? (
                                <div className="slider-img-title">
                                    <span>{image.text}</span>
                                </div>
                            )
                            : null}
                    </div>
                )
                : (
                    <div className="slider-main-img-wrapper">
                        <ResponsiveImage
                            imagesPath={imagesPath}
                            imageSizeParams={imageSizeParams}
                            filename={image.file_name}
                            lazyLoad={this.props.lazyLoad}
                        />
                        {descriptionBlock}
                    </div>
                );
        }

        const sliderSettings = (settings) => {
            if (images.length >= getSlidesToShow(settings)) {
                return settings;
            }
            return {
                ...settings,
                infinite: false,
                speed: 100
            }
        }

        const activeSlideId = getActiveSlideId(images, this.props.activeSlideName);
        return (
            <Slider
                ref={this.props.sliderRefFunction}
                initialSlide={activeSlideId}
                className={
                    images.length >= getSlidesToShow(this.props.settings)
                        ? this.props.className
                        : this.props.className + ' slick-no-slides'
                }
                {...sliderSettings(this.props.settings)}>
                {Object.values(images).map((image, i) => {
                return (
                    <div className="slider-img-container" key={i}>
                        {responsiveImage(image)}
                    </div>
                )
            })}
            </Slider>
        );
    }
}

GalleryComponent.propTypes = {
    imagesPath: PropTypes.string.isRequired

};

export default GalleryComponent;
